<div class="tab-pane">
    <div class="row">
        <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
        <div class="col-lg-12">
            <div class="card rule-book-card">
                <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
                <div class="card-header">
                    <span class="text-primary">ORGANISE REPORTING TEMPLATES</span>
                    <span class="float-right mt-2">
                        <button type="button" class="btn btn-primary btn-sm" (click)="addRow()">Add Row</button>
                    </span>
                </div>
                <div class="card-body">
                    <div class="table-responsive box-shadow setHeight table-cont mt-2" #tableContent>
                        <table class="table table-fixed table-hover mb-0" id="regulation-table"
                            style="min-width: 300px">
                            <thead>
                                <tr>
                                    <th class="pointer col-lg-3">Sidebar
                                    </th>
                                    <th class="pointer col-lg-3">Collapsed/Open
                                    </th>
                                    <th class="pointer col-lg-4">Report</th>
                                    <th class="pointer col-lg-2">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <div *ngFor="let item of allLibraryMenu;let i=index">
                                    <tr>
                                        <td class="col-lg-3">
                                            <input type="text" class="form-control form-control-sm"
                                                [(ngModel)]="item.libraryName" value="{{item.libraryName}}"
                                                (keyup)="onKeydownLibraryName(i)" (change)="libraryNamechange(i)" />
                                            <span class="text-danger mt-1 "
                                                *ngIf="item.isLibraryNameRequired"><small>Library Name is
                                                    required</small></span>
                                            <span class="text-danger mt-1 "
                                                *ngIf="item.isLibraryNameExist"><small>Library Name already
                                                    exist</small></span>
                                        </td>
                                        <td class="col-lg-3 select-group">
                                            <div class="customSelect">
                                                <div class="select">
                                                    <select class="form-control form-control-sm"
                                                        [value]="item.isCollapsed" [(ngModel)]="item.isCollapsed"
                                                        (change)="collapsedFunction(i,$event.target.value)">
                                                        <option *ngFor="let isCol of isCollapsedDD"
                                                            value="{{isCol.value}}">{{isCol.title}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="col-lg-4">
                                            <mat-chip-grid #templateList>
                                                <mat-chip-row class="custom_chip"
                                                    *ngFor="let template of item.ruleBook | rulebookStringToArray"
                                                    [selectable]="selectable" [removable]="removable"
                                                    (removed)="removeTemplate(template,i)">
                                                    {{template}}
                                                    <mat-icon matChipRemove *ngIf="removable">clear</mat-icon>
                                                </mat-chip-row>
                                                <input
                                                    class="form-control form-control-sm mat-autodd-input border-bottom"
                                                    #trigautoTemplate="matAutocompleteTrigger" #templateInput
                                                    [formControl]="searchTemplateCntrl"
                                                    [matAutocomplete]="templateAutocomplete"
                                                    [matChipInputFor]="templateList"
                                                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                                    [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
                                                    (matChipInputTokenEnd)="addTemplate($event, item.ruleBook, i)"
                                                    (click)="openTemplateLibraryAutoComplete()" />
                                            </mat-chip-grid>
                                            <mat-autocomplete #templateAutocomplete="matAutocomplete"
                                                (optionSelected)="selectedMultipleTemplate($event, item.ruleBook, i)">
                                                <mat-option *ngFor="let template of searchedTemplate"
                                                    [value]="template.columnName">
                                                    {{template.columnName}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </td>
                                        <td class="col-lg-2">
                                            <span class="cursor-pointer fg-blue mr-1"
                                                (click)="saveRulebookDetails(i)"><span
                                                    class="fa fa-floppy-o text-dark"></span>
                                                <span class="text-primary ml-1">Save</span>
                                            </span>
                                            <span class="cursor-pointer fg-red ml-2"
                                                (click)="removeRulebookDetails(i,item.id)"><span
                                                    class="fa fa-trash text-red"></span>
                                                <span class="text-danger ml-1">Delete</span>
                                            </span>
                                        </td>
                                    </tr>
                                </div>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>